import { useLayoutEffect, useState } from "react";

const useHeaderMobileDetect = () => {
    const [isMobileHeader, setIsMobileHeader] = useState(false);

    useLayoutEffect(() => {
        const handleResize = () => {
            setIsMobileHeader(window.innerWidth < 1199);
        };

        handleResize();

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return { isMobileHeader };
};

export default useHeaderMobileDetect;